import React, { useMemo } from "react";
import PropTypes from "prop-types";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const CustomToolbar = ({ wordCount, maxWords }) => (
  <div id="toolbar">
    <span className="ql-formats">
      <button className="ql-bold" />
      <button className="ql-italic" />
      <button className="ql-underline" />
    </span>
    <span className="ql-formats">
      <select className="ql-size" defaultValue="medium">
        <option value="small" />
        <option value="medium" />
        <option value="large" />
        <option value="huge" />
      </select>
    </span>
    <span className="ql-formats">
      <button className="ql-list" value="bullet" />
      <button className="ql-list" value="ordered" />
    </span>

    <div className="ql-word-count">
      {wordCount.toLocaleString()} / {maxWords.toLocaleString()} words
    </div>
  </div>
);

CustomToolbar.propTypes = {
  wordCount: PropTypes.number.isRequired,
  maxWords: PropTypes.number.isRequired,
};

const RichTextEditor = ({ value, onChange, placeholder = "Description", maxWords = 10000 }) => {
  const wordCount = useMemo(() => {
    if (!value) return 0;
    const plainText = value.replace(/<[^>]*>/g, "").trim();
    return plainText.split(/\s+/).filter((word) => word.length > 0).length;
  }, [value]);

  const modules = useMemo(
    () => ({
      toolbar: {
        container: "#toolbar",
      },
    }),
    []
  );

  const formats = ["bold", "italic", "underline", "size", "list", "bullet"];

  const handleChange = (content) => {
    const plainText = content.replace(/<[^>]*>/g, "").trim();
    const words = plainText.split(/\s+/).filter((word) => word.length > 0).length;
    if (words <= maxWords || !content) {
      onChange(content);
    }
  };

  return (
    <div className="rich-text-editor-wrapper">
      <CustomToolbar wordCount={wordCount} maxWords={maxWords} />
      <ReactQuill theme="snow" value={value || ""} onChange={handleChange} modules={modules} formats={formats} placeholder={placeholder} />
    </div>
  );
};

RichTextEditor.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  maxWords: PropTypes.number,
};

RichTextEditor.defaultProps = {
  value: "",
  placeholder: "Description",
  maxWords: 10000,
};

export default RichTextEditor;
